import type { Workspace, WorkspaceConfig } from "@storyboard/web-client";

const workspaceConfigs = new Map<string, WorkspaceConfig>();

export function updateWorkspaceConfig(workspace: Workspace) {
  if (workspace.config) {
    workspaceConfigs.set(workspace.id, workspace.config);
  }
}

export function getWorkspaceConfig(workspaceId: string): WorkspaceConfig | undefined {
  return workspaceConfigs.get(workspaceId);
}

export function handsFreeEnabledForWorkspace(workspaceId: string) {
  const config = getWorkspaceConfig(workspaceId);
  return config?.handsFree?.status === "all";
}

export function getWorkspaceLanguages(workspaceId: string) {
  const workspaceConfig = getWorkspaceConfig(workspaceId);
  if (!workspaceConfig) return [];
  return workspaceConfig.allowedLanguages ?? [];
}
